module.exports = __webpack_public_path__ + "img/nodata.0ea5b379.png";